// eslint-disable-next-line max-len
export { default as IconsRowWithTitleAndDescription } from './IconsRowWithTitleAndDescription';
